import React, { useEffect } from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { QuizEditor } from "../features/quiz";
import Library from "../pages/Library";
import Discovery from "../pages/Discovery";
import useUrl from "../hooks/useUrl";
import DashboardLayout from "../layouts/DashboardLayout";
import useModal from "../hooks/useModal";

import GibblyAcademy from "../pages/GibblyAcademy";
import FreeTrial from "../features/stripe/components/FreeTrial";
import Purchase from "../features/stripe/components/Purchase";
import Pricing from "../pages/Pricing";

import HistoryRoutes from "../features/history/routes/HistoryRoutes";
import { useCanvasConffeti } from "../hooks/useCanvasConfetti";
import Settings from "../pages/Settings";

export default function DashboardRoutes() {
  const url = useUrl();
  const { fireCannon } = useCanvasConffeti();

  const [FreeTrialModal, setShowFreeTrialModal] = useModal(
    {
      title: "You're a rockstar 🥳",

      ReactComponent: () => <FreeTrial />,
      onHide: () => {
        setParams({});
      },
      onShow: () => {
        fireCannon("left", false);
        fireCannon("right", false);
      },
    },
    []
  );
  const [PurchaseModal, setShowPurchaseModal] = useModal(
    {
      title: "You're awesome 🧡",

      ReactComponent: () => <Purchase />,
      onHide: () => {
        setParams({});
      },
      onShow: () => {
        fireCannon("left", false);
        fireCannon("right", false);
      },
    },
    []
  );

  // const { user } = useAuthenticator((context) => {
  //   return [context.user];
  // });

  // useEffect(() => {
  //   checkUserExists();
  // }, [user]);

  // const checkUserExists = useCallback(async () => {
  //   if (user) {
  //     const creatorId = await getCreatorId();
  //     // check if User exists in database
  //     const result = (await RestAPI.get(`/users/${creatorId}`).then((res) =>
  //       res.json()
  //     )) as any as User;

  //     if (Object.keys(result).length > 0) {
  //       // if so, do nothing
  //       return;
  //     }
  //     // if not, show modal
  //     else setShowSetupModal(true);
  //   }
  // }, [user]);

  const [params, setParams] = useSearchParams();

  useEffect(() => {
    if (params.get("startedFreeTrial") === "true") setShowFreeTrialModal(true);
    if (params.get("purchasePremium") === "true") setShowPurchaseModal(true);
  }, [params]);

  return (
    <>
      <FreeTrialModal />
      <PurchaseModal />
      {/* <SetupModal /> */}
      <DashboardLayout>
        <Routes>
          <Route index element={<Library />} />
          {/* <Route index element={<GenerateQuizForm />} />  */}
          {/* <Route path='generate' element={<GenerateQuizForm />} /> */}
          <Route path=":id" element={<QuizEditor key={url.routePath} />} />
          <Route path="library" element={<Library />} />
          <Route path="discover" element={<Discovery />} />
          <Route path="academy" element={<GibblyAcademy />} />
          <Route path="free-trial" element={<FreeTrial />} />
          <Route path="purchase" element={<Purchase />} />
          <Route path="upgrade" element={<Pricing />} />
          <Route path="history/*" element={<HistoryRoutes />} />
          <Route path="settings" element={<Settings />} />
        </Routes>
      </DashboardLayout>
    </>
  );
}
